import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  button: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.text.secondary,
  },
  image: {
    position: 'relative',
    height: 200,
    width: '100%',
    marginBottom: '1rem',
    '&:hover, &$focusVisible': {
      zIndex: 1,
    },
  },
  focusVisible: {},
  src: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  },
  title: {
    position: 'absolute',
    padding: '0.5rem 0',
    bottom: 0,
    width: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '1rem',
    color: '#FDFDFD',
  },
  noImage: {
    marginTop: '0.5rem',
    height: '7rem',
    lineHeight: '7rem',
    width: '100%',
    boxShadow: `inset 0em 0.25em 0.5em ${theme.palette.secondary.light}`,
    textAlign: 'center',
    verticalAlign: 'middle',
    cursor: 'pointer',
  },
  icon: {
    marginBottom: '-0.375rem',
  },
}));
